import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_empty = _resolveComponent("van-empty")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_van_empty, { image: "error" }, {
      description: _withCtx(() => [...(_cache[0] || (_cache[0] = [
        _createElementVNode("p", { style: {"text-align":"center"} }, "抱歉!", -1),
        _createElementVNode("p", { style: {"text-align":"center"} }, "您没有操作权限...", -1),
        _createElementVNode("p", { style: {"text-align":"center"} }, "当前帐号没有操作权限,请联系管理员。", -1)
      ]))]),
      default: _withCtx(() => [
        _createVNode(_component_van_button, {
          round: "",
          type: "danger",
          class: "bottom-button",
          onClick: _ctx.logout
        }, {
          default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
            _createTextVNode(" 退出登录 ", -1)
          ]))]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _: 1
    })
  ]))
}